import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";

export default function EditableBox({edit, children, onDone, onCancel, ...props}) {
    const [isEditing, setEditing] = useState(false);

    const handleBeginEditing = (event) => {
        setEditing(true)
    }

    const handleDoneEditing = (event) => {
      setEditing(false)
      if (onDone && typeof(onDone) === 'function') {
          onDone(event)
      }
    }

    const handleCancelEditing = (event) => {
      setEditing(false)
      if (onCancel && typeof(onCancel) === 'function') {
          onCancel(event)
      }
    }


    return (
        <Box {...props}>
            {isEditing ?
            (
                <Box>
                    {edit}
                </Box>
            ) : (
                <Box onClick={(e) => handleBeginEditing(e)}>
                    {children}
                </Box>
            )}
            {isEditing && 
                <Box>
                    <Button onClick={handleDoneEditing}>Done</Button>
                    <Button onClick={handleCancelEditing}>Cancel</Button>
                </Box>
            }
        </Box>
    )
};